import { Box, Card, Stack, Text } from '@ltvco/refresh-lib/theme';

interface NameUsageProps {
  genderAssociation?: string;
  globalUsage?: string;
}

export function NameUsage({ genderAssociation, globalUsage }: NameUsageProps) {
  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: '12px', p: 0, height: '100%' }}
    >
      {/* Main heading */}
      <Stack
        justifyContent="center"
        sx={{
          backgroundColor: 'background.default',
          borderBottom: '1px solid',
          borderColor: 'divider',
          px: 3,
          py: 2,
          minHeight: 56,
        }}
      >
        <Text variant="h5" fontWeight="bold" sx={{ margin: 0 }}>
          Name Usage
        </Text>
      </Stack>

      {/* Content */}
      <Box sx={{ p: 3 }}>
        <Stack spacing={3} alignItems="flex-start">
          {/* Gender Association section */}
          <Box>
            <Text variant="h5" fontWeight="semibold" sx={{ mb: 1 }}>
              Gender Association
            </Text>
            <Text variant="body2">{genderAssociation}</Text>
          </Box>

          {/* Global Usage section */}
          <Box>
            <Text variant="h5" fontWeight="semibold" sx={{ mb: 1 }}>
              Global Usage
            </Text>
            <Text variant="body2">{globalUsage}</Text>
          </Box>
        </Stack>
      </Box>
    </Card>
  );
}
